import { Button, Dialog } from 'Components/Core';
import { buildAgsRevisionDownloadUri } from 'Data/ViewModels/Ags/IAgsExportRevision';
import { IDialogParams } from './types';

const DownloadFileConfirmationDialog: React.FC<IDialogParams> = ({ revisionId, dialogVisibleState, onClose }) => {
  const dialogButtons = [
    <Button
      primary
      onClick={() => {
        onClose(false);
      }}
      href={buildAgsRevisionDownloadUri(revisionId)}
    >
      Yes
    </Button>,
    <Button onClick={() => onClose(false)}>No</Button>,
  ];

  return (
    <Dialog
      onClose={() => onClose(false)}
      visible={dialogVisibleState}
      buttons={dialogButtons}
      title="Downloading file with errors"
    >
      Are you sure you want to download this file?
    </Dialog>
  );
};

export { DownloadFileConfirmationDialog };
